import { useCallback, useEffect, useRef, useState } from "react";

/** Mask an email for display on the OTP step: j••••@oldmutual.com.gh */
export const maskEmail = (email = "") => {
  const [user, domain] = email.split("@");
  if (!domain) return email;
  const head = user.slice(0, 1);
  return `${head}${"•".repeat(Math.max(3, user.length - 1))}@${domain}`;
};

/** Mask a phone for display on the OTP step: •••• •••• 1234 */
export const maskPhone = (phone = "") => {
  const digits = phone.replace(/\D/g, "");
  if (digits.length < 4) return phone;
  return `•••• •••• ${digits.slice(-4)}`;
};

/** Mask an email or phone, whichever the string looks like. */
export const maskLogin = (login = "") =>
  login.includes("@") ? maskEmail(login) : maskPhone(login);

/**
 * A resend cooldown timer. Call start() after a code is sent; `cooldown`
 * counts down to 0 so the resend button can disable itself in the meantime.
 */
export const useResendCooldown = (seconds = 30) => {
  const [cooldown, setCooldown] = useState(0);
  const timer = useRef(null);

  const start = useCallback(() => setCooldown(seconds), [seconds]);

  useEffect(() => {
    if (cooldown <= 0) return undefined;
    timer.current = setTimeout(() => setCooldown((c) => c - 1), 1000);
    return () => clearTimeout(timer.current);
  }, [cooldown]);

  return { cooldown, start };
};
